"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const FormError_1 = __importDefault(require("./FormError"));
const FormGroup_1 = __importDefault(require("./FormGroup"));
const FormNote_1 = __importDefault(require("./FormNote"));
const FormComponent = (0, react_1.forwardRef)(({ children, className, large, onSubmit, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("form", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-form', large && 'usa-form--large', className), onSubmit: onSubmit, ...props, children: children }));
});
const Form = Object.assign(FormComponent, { Error: FormError_1.default, Group: FormGroup_1.default, Note: FormNote_1.default });
exports.default = Form;
